import { Typography } from "@commonlibs";
import clsx from "clsx";
import TabsModalFooter from "ui/common/components/feedback/TabsModal/TabsModalFooter/TabsModalFooter";
import Form from "ui/common/components/input/Form/Form";
import useTranslate from "ui/locale/hooks/useTranslate";
import usePointConversionRate from "ui/point/query/usePointConversionRate";
import { UpdateConversionRateState } from "./UpdateConversionRateModal.types";
import useSetTabsState from "ui/common/components/feedback/TabsModal/hooks/useSetTabsState";
import useGoToNextTab from "ui/common/components/feedback/TabsModal/hooks/useGoToNextTab";
import PencilIcon from "ui/common/icons/PencilIcon";
import {
    SetConversionRateTabRoot,
    InfoBox,
    TableContainer,
    TableHeader,
    TableRow,
    TableCell,
    EditableCell,
    EditIconButton,
} from "./SetConversionRateTab.styles";
import useCloseTabModal from "ui/common/components/feedback/TabsModal/hooks/useCloseTabModal";

export interface SetConversionRateTabProps {
    className?: string;
    style?: React.CSSProperties;
}

function SetConversionRateTab({ className, ...rest }: SetConversionRateTabProps) {
    const translate = useTranslate();
    const { data: defaultConversionRate = 0 } = usePointConversionRate();
    const setTabState = useSetTabsState<UpdateConversionRateState>();
    const goToNextTab = useGoToNextTab();
    const closeModal = useCloseTabModal();

    function handleSubmit() {
        closeModal();
    }

    function handleEditIconClick() {
        setTabState({ conversionRate: 0 });
        goToNextTab();
    }

    return (
        <Form className={clsx("set-conversion-rate-tab", className)} onSubmit={handleSubmit} {...rest}> {/* skipcq: JS-0415 */}
            {/* skipcq: JS-0415 */}
            <SetConversionRateTabRoot>
                <InfoBox>
                    <Typography variant="body2Strong" style={{ color: "#495057", fontSize: "14px", lineHeight: "1.5" }}>
                        {translate("conversionRateDescription")}
                    </Typography>
                </InfoBox>

                <TableContainer>
                    <TableHeader>
                        <TableCell>
                            <Typography variant="body2Strong" style={{ color: "#43398E", fontWeight: "600", fontSize: "14px" }}>
                                {translate("country")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2Strong" style={{ color: "#43398E", fontWeight: "600", fontSize: "14px" }}>
                                {translate("currency")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2Strong" style={{ color: "#43398E", fontWeight: "600", fontSize: "14px" }}>
                                {translate("pidekyPointValue")}
                            </Typography>
                        </TableCell>
                    </TableHeader>

                    <TableRow>
                        <TableCell>
                            <Typography variant="body2Strong" style={{ color: "#000000", fontSize: "14px" }}>
                                {translate("colombia")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2Strong" style={{ color: "#000000", fontSize: "14px" }}>
                                {translate("cop")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <EditableCell>
                                <Typography
                                    variant="body2Strong"
                                    style={{ color: "#000000", fontSize: "14px", textAlign: "center", flex: 1 }}
                                >
                                    ${Number(defaultConversionRate).toString()}
                                </Typography>
                                <EditIconButton type="button" onClick={handleEditIconClick} title={translate("confirm")}>
                                    <PencilIcon viewBox="0 0 32 32" />
                                </EditIconButton>
                            </EditableCell>
                        </TableCell>
                    </TableRow>
                </TableContainer>
            </SetConversionRateTabRoot>

            <TabsModalFooter mainLabel={translate("save")} mainType="submit" />
        </Form>
    );
}

export default SetConversionRateTab;
